export default {
    nl: {
        intro: {
            subtitle: 'Front-end development',
            title: 'Alles klikbaar maken.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/front-end-development/hero.jpg',
        },
        type: 'Front-end development',
        title: 'Front-end development: Van design tot vlekkeloze UI',
        description:
            'Van design naar interactieve UI met front-end development. Onze experts creëren responsive websites met up-to-date technieken.',
        content: [
            {
                type: 'text',
                title: 'Front-end development',
                content:
                    'Front-end vormt het zichtbare en interactieve deel van een website of app voor gebruikers, beter bekend als de user interface (UI). Het is in essentie het gezicht van de applicatie als onderdeel van het gehele UI-UX design. Front-end gaat verder dan alleen uiterlijk; het vertegenwoordigt hoe een product voelt en reageert. Een front-end developer transformeert het visual design naar programmeerbare code. Hierbij is er bijzondere aandacht voor zaken zoals laadtijd en compatibiliteit met verschillende apparaten en browsers.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/laptops-meeting.webp',
                ],
            },
            {
                type: 'text',
                title: 'Front-end development',
                content: `
                    Voordat het product tot stand komt heeft ons UX-team eerst zorgvuldig designs ontworpen en getest met wireframes en prototypes. Hieruit is een design system uit voortgekomen. Deze resultaten vormen een basis waarmee onze front-end developers aan de slag gaan met het ontwikkelen van de voorkant van je product.
                    <br><br>
                    Onze developers zorgen ervoor dat je website vlekkeloos functioneert over verschillende apparaten, besturingssystemen en browsers. Daarnaast is het essentieel dat de website intuïtief, snel en zoekmachine vriendelijk is. Hiervoor wenden de developers zich tot talen als HTML, JavaScript en TypeScript, ondersteund door (S)CSS voor styling. Na het coderen, onderwerpen we het product aan uitvoerige tests om te garanderen dat het voldoet aan onze hoge standaard voordat we overgaan tot implementatie.
                `,
            },
            {
                type: 'quote',
                content:
                    'Front-end gaat verder dan alleen uiterlijk; het vertegenwoordigt hoe een product voelt en reageert.',
            },
            {
                type: 'text',
                title: 'Onze unieke werkwijze van front-end development',
                content: `
                    Bij 23G zijn we niet alleen gepassioneerd, maar ook altijd up-to-date op het gebied van Front-end development. Of we nu bezig zijn met moderne frameworks zoals React of Vue.js, onze toewijding en leergierigheid betekent dat we altijd klaar staan met de nieuwste technieken en benaderingen.
                    <br><br>
                    Bij ons draait alles om teamwork. Ons front-end team werkt hand in hand met ontwerpers, back-end developers en andere betrokkenen. Samen zorgen we dat de Front-end development naadloos aansluit op jouw bedrijfsdoelen en merk. We zijn niet alleen goed in het omzetten van visuele concepten, maar ook in het schrijven van strakke en georganiseerde code. Voor ons is elk project team effort en samen gaan we voor het beste resultaat.
                `,
            },
            {
                type: 'case',
                case: 'ferring',
            },
        ],
        related_services: ['client-portal', 'back-end-development', 'api'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
